document.addEventListener('DOMContentLoaded', function () {

  // ---- Nav solid-on-scroll ----
  var nav = document.getElementById('siteNav');
  if (nav) {
    var onScroll = function () {
      if (window.scrollY > 40) nav.classList.add('is-solid');
      else nav.classList.remove('is-solid');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- Mobile menu ----
  var menuBtn = document.querySelector('[data-menu-toggle]');
  var mobilePanel = document.querySelector('[data-mobile-panel]');
  if (menuBtn && mobilePanel) {
    menuBtn.addEventListener('click', function () {
      mobilePanel.classList.toggle('is-open');
    });
    mobilePanel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobilePanel.classList.remove('is-open'); });
    });
  }

  // ---- Search toggle ----
  var searchBtn = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (searchBtn && searchBar) {
    searchBtn.addEventListener('click', function () {
      searchBar.classList.toggle('is-open');
      if (searchBar.classList.contains('is-open')) {
        var input = searchBar.querySelector('input');
        if (input) input.focus();
      }
    });
  }

  // ---- Category tab filter (works on any grid with [data-filter-grid]) ----
  document.querySelectorAll('[data-filter-grid]').forEach(function (grid) {
    var gridId = grid.getAttribute('data-filter-grid');
    var tabs = document.querySelectorAll('[data-filter-tabs="' + gridId + '"] .tab');
    var cards = grid.querySelectorAll('[data-cat]');
    function applyFilter(val) {
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-filter') === val); });
      cards.forEach(function (c) {
        var show = (val === 'All' || c.getAttribute('data-cat') === val);
        if (show) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { applyFilter(t.getAttribute('data-filter')); });
    });
    document.querySelectorAll('[data-filter-link][data-filter-target="' + gridId + '"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        applyFilter(a.getAttribute('data-filter-link'));
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  });

  // ---- Newsletter (Shopify customer form, just show a success note) ----
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var note = form.parentElement.querySelector('[data-newsletter-success]');
      if (note) { setTimeout(function () { note.hidden = false; form.hidden = true; }, 50); }
    });
  });

  // ---- Product quantity steppers ----
  document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="number"]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // ---- Product media thumbnail switch ----
  document.querySelectorAll('[data-product-thumbs]').forEach(function (wrap) {
    var main = document.querySelector(wrap.getAttribute('data-product-thumbs'));
    wrap.querySelectorAll('img').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) main.src = thumb.getAttribute('data-full');
        wrap.querySelectorAll('img').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  // ---- Cart line quantity auto-submit ----
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  // ---- Product recommendations (fetched via Shopify's native endpoint) ----
  document.querySelectorAll('[data-recommendations-wrapper]').forEach(function (wrap) {
    var baseUrl = wrap.getAttribute('data-url');
    var sectionId = wrap.getAttribute('data-section-id');
    var productId = wrap.getAttribute('data-product-id');
    var limit = wrap.getAttribute('data-limit') || 4;
    if (!baseUrl || !productId) return;
    var url = baseUrl + '?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit) + '&intent=related';
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('ProductRecommendations-' + sectionId);
        if (fresh && fresh.innerHTML.trim() !== '') {
          wrap.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () { /* silently leave empty if the fetch fails */ });
  });
});
